import { Inter } from 'next/font/google';

export const inter100 = Inter({
  weight: '100',
  subsets: ['latin'],
  variable: '--font-inter-100',
});

export const inter200 = Inter({
  weight: '200',
  subsets: ['latin'],
  variable: '--font-inter-200',
});

export const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter-400',
});
export const inter400 = inter;

export const inter500 = Inter({
  weight: '500',
  subsets: ['latin'],
  variable: '--font-inter-500',
});

export const inter600 = Inter({
  weight: '600',
  subsets: ['latin'],
  variable: '--font-inter-600',
});

export const inter800 = Inter({
  weight: '800',
  subsets: ['latin'],
  variable: '--font-inter-800',
});
